import * as React from 'react';

import * as styles from './styles.css';

export function CardActionsLayout(props: React.PropsWithChildren<{}>) {
  return <div className={styles['container']}>{props.children}</div>;
}
